import { Link } from 'react-router-dom';
import { castMembers } from '@/mocks/home';

export default function CastSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-700 bg-accent-100 rounded-full mb-4">
            演员阵容
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            顶级卡司倾情演绎
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto leading-relaxed">
            实力派演员阵容，每个角色都是一段值得铭记的传奇
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {castMembers.map((member) => (
            <div
              key={member.name}
              className="group bg-background-50 rounded-lg border border-background-200 overflow-hidden hover:border-primary-200 transition-all duration-300"
            >
              <div className="relative w-full h-72 overflow-hidden">
                <img
                  src={member.imageUrl}
                  alt={`${member.name} - 饰演 ${member.role}`}
                  title={`${member.name} 饰演 ${member.role} - 赤裸特工演员阵容`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="font-heading font-semibold text-base text-foreground-900">
                    {member.name}
                  </h3>
                  <span className="inline-block px-2 py-0.5 text-xs font-medium bg-accent-100 text-accent-700 rounded-md">
                    饰 {member.role}
                  </span>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {member.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/cast"
            className="inline-flex items-center gap-2 px-6 py-2.5 text-sm font-semibold text-primary-600 bg-primary-50 rounded-lg hover:bg-primary-100 transition-all duration-200 no-underline"
          >
            查看完整演员阵容
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}